import { jobOrderColNm } from "constants/jobOrderConstant";

export const printFinanceReportColumns = [
  {
    field: "AptTm",
    headerName: "วันวิ่งงาน",
    printWidth: 0.8,
    printType: "datetime",
    printFormat: "DD/MM/YYYY",
  },
  {
    field: "CusSNm",
    headerName: jobOrderColNm.CusSNm,
    printWidth: 0.7,
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    printWidth: 1,
  },
  {
    field: "ContSizeFull",
    headerName: jobOrderColNm.ContSizeFull,
    printWidth: 0.5,
  },
  {
    field: "TakePlc",
    headerName: jobOrderColNm.TakePlc,
    printWidth: 0.5,
  },
  {
    field: "Loc",
    headerName: jobOrderColNm.Loc,
    printWidth: 1.3,
  },
  {
    field: "JobNo",
    headerName: jobOrderColNm.JobNo,
    printWidth: 1,
  },
  {
    field: "ScSNm",
    headerName: "หัวลาก",
    printWidth: 0.5,
  },
  {
    field: "IncCusRcptTotal",
    headerName: "Advance",
    printWidth: 0.7,
    printType: "number",
    printAlign: "right",
  },
  {
    field: "ScOwnRcptTotal",
    headerName: "ค่าขนส่ง SUB",
    printWidth: 0.7,
    printType: "number",
    printAlign: "right",
  },
  {
    field: "IncOwnRcptTotal",
    headerName: "รายได้ค่าขนส่ง",
    printWidth: 0.7,
    printType: "number",
    printAlign: "right",
  },
  {
    field: "E1Diff",
    headerName: "ส่วนต่าง",
    printWidth: 0.6,
    printType: "number",
    printAlign: "right",
  },
  {
    field: "DocDte",
    headerName: "วันที่่เอกสาร",
    printWidth: 0.7,
  },
  {
    field: "DocNo",
    headerName: "เลขที่เอกสาร",
    printWidth: 1.5,
    printWrapMode: "wrap",
  },
]